import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import useStoreTranslation from 'hooks/useStoreTranslation';

import Toast from '..';

export interface ToastProps {
  type: 'success' | 'danger' | 'warning';
  message?: string;
  i18nMessage?: string;
  noButton?: boolean;
}
interface ToastCreateContext {
  add: (content: ToastProps) => void;
  remove: (id: string) => void;
}

interface ToastProviderProps {
  children?: JSX.Element;
}

const ToastContext = React.createContext({} as ToastCreateContext);

export const ToastProvider = ({ children }: ToastProviderProps) => {
  const { t } = useStoreTranslation();
  const [toasts, setToast] = useState<{ id: string; content: ToastProps }[]>([]);

  const generateID = () => {
    const first = String(Math.random() * 46656);
    const second = String(Math.random() * 46656);

    return first + second;
  };

  const add = (content: ToastProps) => {
    const id = generateID();
    setToast([...toasts, { id, content }]);
  };

  const remove = (id: string) => {
    setToast(toasts.filter((toast: { id: string }) => toast.id !== id));
  };

  return (
    <ToastContext.Provider value={{ add, remove }}>
      {createPortal(
        toasts.map((toast: { id: string; content: ToastProps }) => (
          <Toast
            key={toast.id}
            remove={() => remove(toast.id)}
            message={(toast.content.i18nMessage ? t(toast.content.i18nMessage) : toast.content.message) || 'Error'}
            type={toast.content.type}
            noButton={toast.content.noButton}
          />
        )),
        document.body,
      )}
      {children}
    </ToastContext.Provider>
  );
};

export default ToastContext;
